<template>
  <div class="flex flex-row gap-5 md:flex-col group lg:col-span-3">
    <a
      :href="hit.url"
      class="block shrink-0 md:aspect-w-1 md:aspect-h-1 lg:hidden"
      :aria-label="hit.title"
    >
      <img
        :src="hit.image"
        alt=""
        aria-hidden="true"
        class="object-cover max-md:h-[100px] max-md:w-[100px] shadow-white"
        height="300"
        loading="lazy"
        width="300"
      >
    </a>
    <div class="relative shrink-0 aspect-w-1 aspect-h-1 max-lg:hidden">
      <img
        :src="hit.image"
        alt=""
        aria-hidden="true"
        class="object-cover"
        height="300"
        loading="lazy"
        width="300"
      >
        
      <QuickViewModalTrigger
        :url="hit.url"
        :title="hit.title"
      />
    </div>
    <a
      :href="hit.url"
      class="flex flex-col gap-1 md:gap-2"
      :aria-label="hit.title"
    >
      <h3 class="text-lg md:text-xl link link--primary">
        {{ hit.title }}
      </h3>    
      <AisSnippet
        attribute="excerpt"
        :hit="hit"
        :class-names="{
          'ais-Snippet': 'prose prose-sm',
        }"
      /> 
      <div class="space-x-1 text-lg">
        <template v-if="isDiscounted(hit)">
          <span class="text-lg font-bold">
            {{ isFree(hit.discountedPrice ?? 0) ? 'FREE' : formatCurrency(hit.discountedPrice) }}
          </span>
          <s class="text-gray-blue-500">
            {{ formatCurrency(hit.fullPrice) }}
          </s>
        </template>
        <span
          v-else
          class="text-lg font-bold"
        >
          {{ isFree(hit.fullPrice ?? 0) ? 'FREE' : formatCurrency(hit.fullPrice) }}
        </span>
      </div>
    </a>
  </div>
</template>
<script lang="ts">
export default {
  name: 'ProductHit',
}
</script>
<script setup lang="ts">
import { AisSnippet } from 'vue-instantsearch/vue3/es'
import { Hit } from '~/types/Hit'

import { formatCurrency } from '~/utils/format'

import QuickViewModalTrigger from '../partials/QuickViewModalTrigger.vue'

defineProps<{ hit: Hit }>()

const isDiscounted = hit => Number.isFinite(hit.discountedPrice)
const isFree = (price: number) => price === 0
</script>

